import axios from "axios";
import VueCookies from "vue-cookies";

import { logger } from "@/services/log.js";
import { attachTrackingHeaders } from "@/utils/requestTracking";
import { getAccessBrand } from "./brand";
import router from "../router";
import { appConfig } from "../aLwAJXh7rUuwykLl";
import { getPreviewResponse, isPreviewMode } from "@/utils/previewMode";

const AUTH_RECOVERY_SKIP_PATHS = [
  "/api/v1/user/LoginExternal",
  "/api/v1/user/CheckSocialBind"
];

let refreshTokenPromise = null;

const isAuthRecoverySkipped = config => {
  const url = config?.url || "";
  return AUTH_RECOVERY_SKIP_PATHS.some(path => url.includes(path));
};

const loginExternalOnce = async () => {
  if (!refreshTokenPromise) {
    refreshTokenPromise = import("../store")
      .then(({ default: store }) => store.dispatch("login"))
      .finally(() => {
        refreshTokenPromise = null;
      });
  }

  return refreshTokenPromise;
};

const redirectToValidateTelephone = () => {
  VueCookies.remove("token");
  router.replace({
    path: "/validatetelephone",
    query: {
      redirect: router.currentRoute.value.path
    }
  });
};

axios.interceptors.request.use(function (config) {
  return config;
});

axios.interceptors.response.use(function (response) {
  return Promise.resolve(response.data);
});
const baseURL = getAccessBrand();

const instance = axios.create({
  withCredentials: true,
  baseURL: baseURL,
  responseType: "json"
});

instance.interceptors.request.use(
  function (config) {
    if (isPreviewMode()) {
      const mockResponse = getPreviewResponse(config);

      if (mockResponse) {
        config.adapter = () =>
          Promise.resolve({
            data: mockResponse,
            status: 200,
            statusText: "OK",
            headers: {},
            config,
            request: {}
          });
      }
    }

    config.metadata = { startTime: new Date() };
    attachTrackingHeaders(config);
    if (VueCookies.isKey("token")) {
      config.headers.Authorization = `Bearer ${VueCookies.get("token")}`;
    }
    let lang = null;
    if (VueCookies.isKey("lang")) {
      lang = VueCookies.get("lang").lang;
    }

    config.headers.common["API-KEY"] = appConfig.VUE_APP_API_KEY;
    config.headers.common["PUBLIC-KEY"] = "CRM" || "";
    config.headers.common["LANGUAGE-ID"] = lang || 1;
    config.headers.common["Access-Control-Allow-Origin"] = "*";
    return config;
  },
  function (error) {
    logger({ response: error.response || { config: error.config || {} } });
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function (response, config) {
    checkEmptyFieldChoice(response);
    if (response.data.result == 0) logger({ response });
    return Promise.resolve(response.data);
  },
  async function (error, config) {
    const status = error.response?.status;
    const originalRequest = error.config || error.response?.config;

    if (
      status == 401 &&
      originalRequest &&
      !originalRequest._retry &&
      !isAuthRecoverySkipped(originalRequest)
    ) {
      originalRequest._retry = true;

      try {
        const loginResponse = await loginExternalOnce();
        const token = VueCookies.get("token");

        if (loginResponse?.result == 1 && token) {
          originalRequest.headers = originalRequest.headers || {};
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return instance(originalRequest);
        }
      } catch (e) {
        logger({ response: e?.response || { config: originalRequest } });
      }

      redirectToValidateTelephone();
    }

    logger({ response: error.response || { config: error.config || {} } });
    return Promise.reject(error.response || error);
  }
);
const checkEmptyFieldChoice = response => {
  // ตรวจสอบการใช้ URL
  if (response.config.url.includes("registerform")) {
    const fieldType = [2, 3, 4, 15];
    const excludesFieldId = [16, 17, 18];
    let errorField = [];

    // ฟังก์ชันย่อยที่ใช้สำหรับการตรวจสอบฟิลด์
    const checkField = (fields, fieldLabel) => {
      return fields
        .filter(
          element =>
            fieldType.includes(element.field_type_id) &&
            (element.is_show == 1 || element.show_on_edit_profile == 1)
        )
        .filter(
          element =>
            element.field_choices.length == 0 &&
            !excludesFieldId.includes(element.field_profile_type_id)
        )
        .map(element => `${fieldLabel} : ${element.name}`);
    };

    // ตรวจสอบทั้ง fields และ custom_field
    errorField = [
      ...errorField,
      ...checkField(response.data.detail.result.fields, "Profile"),
      ...checkField(response.data.detail.result.custom_field, "Custom")
    ];

    // ถ้ามีฟิลด์ที่ไม่มีตัวเลือก
    if (errorField.length > 0) {
      logger({
        response,
        action: {
          action: "select options is empty",
          id: 3,
          note: errorField.join(",")
        }
      });
    }
  }

  // ตรวจสอบกรณี redeem_coupon
  if (response.config.url.includes("/Reward/redeem_coupon")) {
    if (response.status == 200 && response.data.detail.length == 0) {
      logger({
        response,
        action: {
          action: "select options is empty",
          id: 3,
          note: "branch list is empty"
        }
      });
    }
  }
};

export { instance, axios };
